import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import * as Highcharts from 'highcharts';
import exporting from 'highcharts/modules/exporting';
import { CrossoverService } from 'src/app/services/crossover.service';
import { ListaPulsantiMercatiComponent } from '../../shared/lista-pulsanti-mercati/lista-pulsanti-mercati.component';
import { CommonModule } from '@angular/common';
import { TradingSystemSummaryComponent } from '../../shared/trading-system-summary/trading-system-summary.component';
import { HighchartsChartModule } from 'highcharts-angular';
exporting(Highcharts)

@Component({
  selector: 'app-ultimi-valori-h1',
  standalone: true,
  templateUrl: './ultimi-valori-h1.component.html',
  styleUrls: ['./ultimi-valori-h1.component.scss'],
  imports: [HighchartsChartModule, TradingSystemSummaryComponent, CommonModule, ListaPulsantiMercatiComponent]
})
export class UltimiValoriH1Component implements OnInit {
  dati: any = []
  datiTable: any = []
  datiTotali: any = []
  headers = ['ora', 'eur', 'usd', 'gbp', 'jpy', 'aud', 'nzd', 'cad', 'chf']
  mercati = ['eur', 'usd', 'gbp', 'jpy', 'aud', 'cad', 'chf', 'nzd'];
  Highcharts: typeof Highcharts = Highcharts;
  HighchartsCambio: typeof Highcharts = Highcharts;
  chartConstructor: string = 'chart';
  chartOptions: Highcharts.Options = {}
  chartOptions2: Highcharts.Options = {}
  chartOptions3: Highcharts.Options = {}

  updateFlag: boolean = false; // optional boolean
  oneToOneFlag: boolean = true; // optional boolean, defaults to false
  runOutsideAngular: boolean = false; // optional boolean, defaults to false
  runOutsideAngularFlag = false; // optional boolean, defaults to false

  oraUltimoValore: string = ''

  optValoriGrafico = [100, 200, 300, 400, 500, 600, 700, 800, 900, 1000]
  mkt1: any = ['eur', 'usd', 'gbp', 'aud', 'cad', 'chf', 'nzd']
  mkt2: any = ['usd', 'gbp', 'jpy', 'aud', 'cad', 'chf', 'nzd']
  loading: boolean = false
  datiOp: any = []
  headersSegnali = ['ora', 'mkt', 'ct open', 'verso', 'prezzo', 'oraclose', 'ct close', 'prezzoclose', 'profit']
  listaMercati: any = []

  constructor(private serv: CrossoverService) { }

  ngOnInit(): void {
    this.caricaDati(200, 0)
  }

  caricaDati(numdati: number = 100, pagina: number = 0) {
    this.serv.listH1(numdati, pagina).subscribe((data: any) => {
      if (data.res == 'ok') {
        this.datiTable = data.dati.slice(0, 10)
        this.serv.listaMercati().subscribe((data: any) => {
          if (data.res == 'ok') {
            this.listaMercati = data.data.filter((el: any) => el.tipo == 'Major' || el.tipo == 'Cross')
            //this.controllaOp()
          }
        })
        this.dati = data.dati.sort((a: any, b: any) => (new Date(a.ora)).getTime() - (new Date(b.ora).getTime()))
        this.datiTotali = data.dati//.sort((a: any, b: any) => a.ora - b.ora)
        this.aggiornaGrafico(this.dati, numdati)
      }
    })
  }

  salvaImg(){
    
  }

  /* controllaOp() {
    let dataDaSalvare: any = []
    this.serv.ultimoOrarioH1().subscribe((data: any) => {
      console.log(data)
      if (data.res == 'ok') {
        data.data.forEach((el: any) => {
          this.datiOp.push(el)
        })
        this.oraUltimoValore = data.data[0] ? data.data[0].ora : ''
        console.log(this.oraUltimoValore)
        this.listaMercati.forEach((mkt: any) => {
          let mkt1 = mkt.market.substring(0, 3).toLowerCase()
          let mkt2 = mkt.market.substring(3, 6).toLowerCase()
          for (let i = 0; i < this.datiTable.length - 1; i++) {
            if (this.datiTable[i]['ora'] <= this.oraUltimoValore) {
              continue
            }
            let level1 = this.datiTable[i][mkt1] - this.datiTable[i][mkt2]
            let level2 = this.datiTable[i + 1][mkt1] - this.datiTable[i + 1][mkt2]
            if (level1 > -30 && level2 < -30) {
              this.serv.ultimoValore(mkt.market, this.datiTable[i]['ora']).subscribe((data: any) => {
                console.log(data)
                let ct_close: any
                let oraclose: any
                let vclose: any
                let bCliuso = false
                for (let j = i - 1; j > 0; j--) {
                  let level3 = this.datiTable[j][mkt1] - this.datiTable[j][mkt2]
                  if (level3 > 20) {
                    bCliuso = true
                    ct_close = level3
                    oraclose = this.datiTable[j]['ora']
                  }
                }
                if (!bCliuso) {
                  ct_close = this.datiTable[0][mkt1] - this.datiTable[0][mkt2]
                  oraclose = this.datiTable[0]['ora']
                }
                let obj = {
                  ora: this.datiTable[i]['ora'],
                  market: mkt.market,
                  verso: 'BUY',
                  vopen: data.data,
                  ct_open: level1,
                  ct_close: ct_close,
                  oraclose: oraclose,
                  vclose: vclose,
                }
                this.datiOp.push(obj)
                dataDaSalvare = [obj]
                this.serv.salvaOpH1(dataDaSalvare).subscribe((data: any) => {
                  console.log(data)
                })
              })
            }
            if (level1 < 30 && level2 > 30) {
              this.serv.ultimoValore(mkt.market, this.datiTable[i]['ora']).subscribe((data: any) => {
                this.datiOp.push({ ora: this.datiTable[i]['ora'], market: mkt.market, verso: 'SELL', vopen: data.data, ct_open: level1 })
                dataDaSalvare = [{ ora: this.datiTable[i]['ora'], market: mkt.market, verso: 'SELL', vopen: data.data, ct_open: level1 }]
                this.serv.salvaOpH1(dataDaSalvare).subscribe((data: any) => {
                  console.log(data)
                })
              })
            }
          }
        })
        this.datiOp.sort((a: any, b: any) => (new Date(a.ora)).getTime() - (new Date(b.ora).getTime()))

      }
    })
  } */

  aggiorna() {
    this.loading = true
    this.serv.aggiornaCrossH1().subscribe((data: any) => {
      console.log(data)
      if (data.res == 'ok') {
        this.serv.listH1(200, 0).subscribe((data: any) => {
          console.log(data)
          if (data.res == 'ok') {
            this.datiTable = data.dati.slice(0, 10)
            this.dati = data.dati.sort((a: any, b: any) => (new Date(a.ora)).getTime() - (new Date(b.ora).getTime()))
            this.datiTotali = data.dati
            this.aggiornaGrafico(this.dati)
            //this.controllaOp()
          }
        })
      }
      this.loading = false
    })
  }

  aggiornaGrafico(dati: any, numeroDato: number = 100) {
    let s1 = dati.map((el: any) => [el.ora, parseFloat(el.eur)])
    let s2 = dati.map((el: any) => [el.ora, parseFloat(el.usd)])
    let s3 = dati.map((el: any) => [el.ora, parseFloat(el.gbp)])
    let s4 = dati.map((el: any) => [el.ora, parseFloat(el.jpy)])
    let s5 = dati.map((el: any) => [el.ora, parseFloat(el.aud)])
    let s6 = dati.map((el: any) => [el.ora, parseFloat(el.nzd)])
    let s7 = dati.map((el: any) => [el.ora, parseFloat(el.cad)])
    let s8 = dati.map((el: any) => [el.ora, parseFloat(el.chf)])
    s1 = s1.splice(s1.length - numeroDato)
    s2 = s2.splice(s2.length - numeroDato)
    s3 = s3.splice(s3.length - numeroDato)
    s4 = s4.splice(s4.length - numeroDato)
    s5 = s5.splice(s5.length - numeroDato)
    s6 = s6.splice(s6.length - numeroDato)
    s7 = s7.splice(s7.length - numeroDato)
    s8 = s8.splice(s8.length - numeroDato)
    let ser: Highcharts.SeriesOptionsType[] = [
      { name: 'eur', type: 'line', data: s1 },
      { name: 'usd', type: 'line', data: s2 },
      { name: 'gbp', type: 'line', data: s3 },
      { name: 'jpy', type: 'line', data: s4 },
      { name: 'aud', type: 'line', data: s5 },
      { name: 'nzd', type: 'line', data: s6 },
      { name: 'cad', type: 'line', data: s7 },
      { name: 'chf', type: 'line', data: s8 },
    ]
    this.chartOptions = {
      title: {
        text: 'CrossOver H1'
      },
      chart: {
        zooming: {
          type: 'x'
        }
      },
      series: ser,
      yAxis: {
        plotLines: [{
          value: 0,
          width: 2,
          color: 'black',
          zIndex: 4
        }]
      },
    }
  }

  valoriGrafico(event: any) {
    let num = event.target.value
    if (num > this.datiTotali.length) {
      this.caricaDati(num, 0)
    } else {
      this.aggiornaGrafico(this.datiTotali, num)
    }
  }

  mercatoSelezionato(mkt: any) {
    console.log(mkt)
    let mkt1 = mkt.market.substring(0, 3).toLowerCase()
    let mkt2 = mkt.market.substring(3, 6).toLowerCase()
    this.serv.valoriCambioH1(mkt1 + mkt2, this.datiTotali[0].ora).subscribe((data: any) => {
      if (data.res == 'ok') {
        let s1 = this.datiTotali.map((el: any) => [el.ora, parseFloat(el[mkt1])])
        let s2 = this.datiTotali.map((el: any) => [el.ora, parseFloat(el[mkt2])])
        let s3 = data.data.map((el: any) => [el.ora, parseFloat(el.vclose)])
        let s1a = this.datiTotali.map((el: any) => [el.ora, parseFloat(el[mkt1]) - parseFloat(el[mkt2])])
        let ser: Highcharts.SeriesOptionsType[] = [
          { name: mkt1, type: 'line', data: s1, dashStyle: 'ShortDot' },
          { name: mkt2, type: 'line', data: s2, dashStyle: 'ShortDot' },
          { name: mkt1 + '-' + mkt2, type: 'line', data: s1a, dashStyle: 'LongDash', color: 'orange' },
          { name: mkt1 + mkt2, type: 'line', data: s3, yAxis: 4, color: 'lightgreen' },
        ]
        this.chartOptions2 = {
          title: {
            text: 'CrossOver H1 ' + mkt1 + mkt2
          },
          chart: {
            zooming: {
              type: 'x'
            }
          },
          yAxis: [{
            plotLines: [{
              value: 0,
              width: 2,
              color: 'black'
            }, {
              value: 30,
              width: 1,
              color: 'green',
              dashStyle: 'LongDash',
              zIndex: 5
            }, {
              value: -30,
              width: 1,
              color: 'green',
              dashStyle: 'LongDash',
              zIndex: 5
            }, {
              value: 20,
              width: 1,
              color: 'red',
              dashStyle: 'LongDashDot',
              zIndex: 5
            }, {
              value: -20,
              width: 1,
              color: 'red',
              dashStyle: 'LongDashDot',
              zIndex: 5
            }]
          },
          {
            title: { text: mkt1 }
          },
          {
            title: { text: mkt2 }
          },
          {
            title: { text: 'CrossTrend' },
          },
          {
            title: { text: 'Cambio' },
            opposite: true
          }
          ],
          series: ser,
          exporting: {
            chartOptions: {
              navigator: {
                enabled: false
              },
              scrollbar: {
                enabled: false
              }
            }
        }
        }

        let ser2: Highcharts.SeriesOptionsType[] = [
          { name: 'CrossTrend', type: 'line', data: s1a, dashStyle: 'LongDash', color: 'orange' },
          { name: mkt1 + mkt2, type: 'line', data: s3, yAxis: 2, color: 'lightgreen' },
        ]
        this.chartOptions3 = {
          title: {
            text: 'CrossTrend H1 ' + mkt1 + mkt2
          },
          chart: {
            zooming: {
              type: 'x'
            }
          },
          xAxis: {
            //type: 'datetime'
          },
          yAxis: [ {
            plotLines: [{
              value: 0,
              width: 2,
              color: 'gray'
            }/*, {
              value: 30,
              width: 1,
              color: 'green',
              dashStyle: 'LongDash',
              zIndex: 5
            }, {
              value: -30,
              width: 1,
              color: 'green',
              dashStyle: 'LongDash',
              zIndex: 5
            }, {
              value: 20,
              width: 1,
              color: 'red',
              dashStyle: 'LongDashDot',
              zIndex: 5
            }, {
              value: -20,
              width: 1,
              color: 'red',
              dashStyle: 'LongDashDot',
              zIndex: 5
            }*/]
          }, 
          {
            title: { text: mkt1 + mkt2 }
          },
          {
            title: { text: 'Cambio' },
            opposite: true
          }
          ],
          series: ser2
        }
      }
    })
  }

}
